export enum AskPageError {
  GENERAL = 'GENERAL',
  LOCATION = 'LOCATION',
  OVERVIEW = 'OVERVIEW',
  OWNERSHIP = 'OWNERSHIP',
  MANAGEMENT = 'MANAGEMENT',
  COMPETITION = 'COMPETITION',
  FINANCIALS = 'FINANCIALS',
  PS = 'PS',
  INVENTORY = 'INVENTORY',
  RESEARCH = 'RESEARCH',
  // Industry Based Question
  MEDICAL = 'MEDICAL',
  GAS = 'GAS',
  DAYCARE = 'DAYCARE',
  SOFTWARE = 'SOFTWARE',
  ACCOUNTING = 'ACCOUNTING',
  PHARMACY= 'PHARMACY',
  MEMBERSHIP = 'MEMBERSHIP',
  FEDEX = 'FEDEX',
  RIA = 'RIA',
  VETERINARY = 'VETERINARY',
  AUTOBODY = 'AUTOBODY',
  GIFT = 'GIFT',
  AIB = 'AIB',
  WHOLESALE = 'WHOLESALE',
}
